import { initCarousel } from '@/braun/Controllers/BraunCarouselController';

export const initRecipeSlider = () => {
  const recipeBoxSlider = document.getElementsByClassName(
    'recipe-box-slides',
  )[0];
  if (recipeBoxSlider) {
    initCarousel(
      recipeBoxSlider,
      {
        slidesPerViewXl: 4,
        slidesPerViewL: 4,
        slidesPerViewM: 3,
        slidesPerViewXs: 1,

        spaceBetweenXl: 20,
        spaceBetweenL: 20,
        spaceBetweenM: 20,
        spaceBetweenXs: 10,

        hideScrollbar: false,
      },
      {
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        roundLengths: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
      },
    );
  }
};

export default () => {
  initRecipeSlider();
};
